import React, { useMemo, useState } from 'react';
import { Col, Nav, Row, Spinner, Tab } from 'react-bootstrap';
import TransaksiService from '../../../services/transaksi/TransaksiService';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/Card';
import ViewHeader from './view/ViewHeader';
import ViewMutu from './view/ViewMutu';
import ViewKomoditi from './view/ViewKomoditi';
import ViewDokumen from './view/ViewDokumen';
import ViewKemasan from './view/ViewKemasan';
import ViewKontainer from './view/ViewKontainer';

const ViewEditEkspor2 = () => {
    const [selectedTab, setSelectedTab] = useState('entitas')
    const [dataHeader, setDataHeader] = useState({})
    const [dataMutu, setDataMutu] = useState({})
    const [dataKomoditi, setDataKomoditi] = useState({})
    const [dataDokumen, setDataDokumen] = useState({})
    const [dataKemasan, setDataKemasan] = useState({})
    const [dataKontainer, setDataKontainer] = useState({})
    const [loading, setLoading] = useState(false)
    const [nomoraju, setNomoraju] = useState(null)

    let transaksiService = useMemo(() => new TransaksiService(), [])

    const navigate = useNavigate()

    const handleSelectTab = async (key) => {
        setLoading(true)
        // console.log(key, ';;', typeof key)
        let noaju = localStorage.getItem('nomorAjuStorage')
        // console.log(noaju)
        setSelectedTab(key)
        let response
        try {
            if (key === 'entitas') {
                if (noaju !== null) {
                    response = await transaksiService.getPpmById(noaju)
                    setDataHeader(response.data)
                } else {
                    setDataHeader({})
                }
            } else if (key === 'mutu') {
                if (noaju !== null) {
                    response = await transaksiService.getPpmMutuById(noaju)
                    setDataMutu(response.data)
                } else {
                    setDataMutu({})
                }
            } else if (key === 'komoditi') {
                if (noaju !== null) {
                    response = await transaksiService.listPpmDetil(noaju, 0, 0, 0, 10)
                    setDataKomoditi(response.data)
                } else {
                    setDataKomoditi({})
                }
            } else if (key === 'dokumen') {
                if (noaju !== null) {
                    response = await transaksiService.listPpmDok(noaju, null, 0, 10)
                    setDataDokumen(response.data)
                } else {
                    setDataDokumen({})
                }
            } else if (key === 'kemasan') {
                if (noaju !== null) {
                    response = await transaksiService.listPpmKemasan(noaju, 0, 10)
                    setDataKemasan(response.data)
                } else {
                    setDataKemasan({})
                }
            } else if (key === 'kontainer') {
                if (noaju !== null) {
                    response = await transaksiService.listPpmContainer(noaju, null, 0, 10)
                    setDataKontainer(response.data)
                } else {
                    setDataKontainer({})
                }
            }
        } catch (error) {
            setDataHeader({})
            setDataMutu({})
            setDataKomoditi({})
            setDataDokumen({})
            setDataKemasan({})
            setDataKontainer({})
        }
        setLoading(false)
    }

    const backToDraft = () => {
        navigate('/permohonan/ekspor/draft')
    }

    useState(() => {
        let nomorAju = localStorage.getItem('nomorAjuStorage')
        const fetchData = async (noaju) => {
            setLoading(true)
            try {
                let response;
                if (selectedTab === 'entitas') {
                    response = await transaksiService.getPpmById(noaju)
                    setDataHeader(response.data)
                } else if (selectedTab === 'mutu') {
                    response = await transaksiService.getPpmMutuById(noaju)
                    setDataMutu(response.data)
                } else if (selectedTab === 'komoditi') {
                    response = await transaksiService.listPpmDetil(noaju, 0, 0, 0, 10)
                    setDataKomoditi(response.data)
                } else if (selectedTab === 'dokumen') {
                    response = await transaksiService.listPpmDok(noaju, null, 0, 10)
                    setDataDokumen(response.data)
                } else if (selectedTab === 'kemasan') {
                    response = await transaksiService.listPpmKemasan(noaju, 0, 10)
                    setDataKemasan(response.data)
                } else if (selectedTab === 'kontainer') {
                    response = await transaksiService.listPpmContainer(noaju, null, 0, 10)
                    setDataKontainer(response.data)
                }
            } catch (error) {
                // console.log(error)
            } finally {
                setLoading(false)
            }
        }
        fetchData(nomorAju)
        setNomoraju(nomorAju)
    }, [selectedTab])

    return (
        <>
            <div>
                <Row>
                    <Col sm="12" lg="13">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Form Permohonan Pemeriksaan Mutu</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Tab.Container defaultActiveKey="entitas" onSelect={handleSelectTab} activeKey={selectedTab}>
                                    <Nav variant='tabs'>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'entitas'}>Entitas</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'komoditi'} disabled={nomoraju == null}>Komoditi</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'mutu'} disabled={nomoraju == null}>Mutu</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'dokumen'} disabled={nomoraju == null}>Dokumen</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'kemasan'} disabled={nomoraju == null}>Kemasan</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'kontainer'} disabled={nomoraju == null}>Kontainer</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'entitas'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewHeader dataHeader={dataHeader} cancelHeader={backToDraft} saveHeader={handleSelectTab} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'komoditi'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewKomoditi dataKomoditi={dataKomoditi} saveKomoditi={handleSelectTab} cancelKomoditi={handleSelectTab} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'mutu'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewMutu dataMutu={dataMutu} saveMutu={handleSelectTab} cancelMutu={handleSelectTab} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'dokumen'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewDokumen dataDokumen={dataDokumen} saveDokumen={handleSelectTab} cancelDokumen={handleSelectTab} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'kemasan'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewKemasan dataKemasan={dataKemasan} saveKemasan={handleSelectTab} cancelKemasan={handleSelectTab} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'kontainer'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewKontainer dataKontainer={dataKontainer} saveKontainer={backToDraft} cancelKontainer={handleSelectTab} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ViewEditEkspor2